import { INTERNAL_UNKNOWN } from '@utils/constants';

export const AD_CONTENT_DIMENSION = 'AD_REQUESTED';

export const adContentMap = {
  false: 'withoutAds',
  true: 'withAds',
  [INTERNAL_UNKNOWN]: INTERNAL_UNKNOWN,
};

export const AD_CONTENT_KEYS = [
  'Attempts',
  'EndedPlays',
  'HighExitBeforeVideoStartPercentage',
  'HighStartupTimePercentage',
  'LowBitratePercentage',
  'VideoPlaybackFailuresTechPercentage',
  'HighRebufferingPercentage',
  'VideoStartFailuresTechPercentage',
];
export const AD_WITH_PREROLL = 'WithPreRoll';
export const AD_WITHOUT_PREROLL = 'WithoutPreRoll';
